"use client";

import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { logError } from "@up/data";

import type { ReactNode } from "react";

function FallbackComponent({
  error,
  message,
}: {
  error: unknown;
  message: string;
}) {
  useEffect(() => {
    if (error) {
      logError({ action: message, error });
    }
  }, [error, message]);

  return null;
}

export function ClientErrorBoundary({
  children,
  message = "React error boundary",
}: {
  children: ReactNode;
  message?: string;
}) {
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => (
        <FallbackComponent error={error} message={message} />
      )}
    >
      {children}
    </ErrorBoundary>
  );
}
